<div class="security-model-history">

  <div class="block">Attributes of securities in this model have been edited as noted below:</div>

  <div class="block editorDisplayBanner">

    <div class="security-model-history-header-block">
      <span class="bold" style="padding-right:10px;">Date Created / By:</span>
      @if (createModifyData.createdDate!=null) {
        <span
          style="padding-right:10px;">{{createModifyData.createdDate | easternTime | date:'MM/dd/yyyy h:mm a'}}
        ET</span>
      }
      <span>{{createModifyData.createdBy}}</span>
    </div>

    <div class="security-model-history-header-block">
      <span class="bold" style="padding-right:10px;">Date Last Edited / By:</span>
      @if (createModifyData.lastModifiedHistoryDate != null || createModifyData.modifiedDate != null) {
      <span style="padding-right:10px;">
        {{ (createModifyData.lastModifiedHistoryDate ?? createModifyData.modifiedDate) | easternTime | date:'MM/dd/yyyy h:mm a' }} ET
      </span>
      }
      <span >{{createModifyData.historyLastModifiedBy || createModifyData.modifiedBy}}</span>
    </div>

    <div class="right" style="margin-right: 1px;">
      <span>
        <fa-icon (click)="exportModelHistory()" [icon]="faDownload" [tooltipTitle]="'Export'"
        class="irb-green clickable" id="exportLink" tooltip></fa-icon>
      </span>
    </div>
  </div>


  @if (data && !isUiTest) {
    <irb-inventory-grid (gridReady)="onGridReady($event)"
      [gridHeight]="'240px'"
      [gridOptions]="gridOptions"
      [showSideBar]="false"
      [style.height]="'240px'"
    [style.width]="'100%'"></irb-inventory-grid>
  }

  @if (ges.getExportOptions().isGridRequired) {
    <irb-ag-grid-export (callbackMethod)="ges.resetExportGrid($event)"
      [exportOptions]="ges.getExportOptions()"
      [exportType]="'csv'"
      [isGridRequired]="ges.getExportOptions().isGridRequired"
    [rowData]="ges.getExportOptions().gridOptions.rowData"></irb-ag-grid-export>
  }
</div>
